const URLS = {
  V1: "https://devapi.orbitshift.ai/v1",
  V2: "https://devapi.orbitshift.ai/v2",
  ASSETS: "https://devapi.orbitshift.ai/assets",
  OS_LITE: "https://devapi.orbitshift.ai/v1/os_lite"
}

export default URLS
